import { useState, useEffect } from "react";
import { api } from "../api.js";
import { USERS } from "../lib/user.js";

const NAMES = ["Matthijs", "Anna"];
function renderWithTags(text) {
  const parts = text.split(/(@Matthijs|@Anna)/gi);
  return parts.map((p, i) =>
    /^@(Matthijs|Anna)$/i.test(p)
      ? <span key={i} style={{ color:"#2d5a8e", fontWeight:700 }}>{p}</span>
      : <span key={i}>{p}</span>
  );
}
function mentions(text, name) {
  return new RegExp(`@${name}\\b`, "i").test(text || "");
}

export function TownNotes({ townName, readOnly = false, currentUser }) {
  const key = `notes_${townName.replace(/\s+/g, "_")}`;
  const [thread, setThread]   = useState([]);
  const [visited, setVisited] = useState(false);
  const [rating, setRating]   = useState(0);
  const [draft, setDraft]     = useState("");
  const [loading, setLoading] = useState(true);

  const me = USERS[currentUser]?.name || "Iemand";

  useEffect(() => {
    api.getSetting(key).then(d => {
      if (d) {
        setVisited(!!d.visited); setRating(d.rating || 0);
        if (Array.isArray(d.thread)) setThread(d.thread);
        else if (d.note) setThread([{ author: "", text: d.note, ts: d.ts || Date.now() }]); // migratie
      }
      setLoading(false);
    });
  }, [key]);

  const persist = (next) => api.putSetting(key, next).catch(() => {});

  const toggleVisited = v => { setVisited(v); persist({ visited:v, rating, thread }); };
  const setStars = n => { if (readOnly) return; setRating(n); persist({ visited, rating:n, thread }); };
  const addEntry = () => {
    const text = draft.trim();
    if (!text) return;
    const next = [...thread, { author: me, text, ts: Date.now() }];
    setThread(next); setDraft(""); persist({ visited, rating, thread: next });
  };

  if (loading) return null;

  // Voor jou: een notitie van de ander die jou tagt
  const forMe = currentUser && NAMES.includes(me)
    ? thread.some(e => e.author !== me && mentions(e.text, me))
    : false;

  return (
    <div style={{ padding: "16px 0" }}>
      {forMe && (
        <div style={{ background:"#eef4fb", border:"1px solid #cfe0f3", borderRadius:8,
                      padding:"7px 12px", fontSize:12, color:"#2d5a8e", marginBottom:12 }}>
          ✉ Er is een notitie waarin je getagd bent.
        </div>
      )}

      <label style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10, fontSize:13, cursor:readOnly?"default":"pointer" }}>
        <input type="checkbox" checked={visited} disabled={readOnly} onChange={e => toggleVisited(e.target.checked)} />
        <span>Al bezocht</span>
      </label>
      <div style={{ display:"flex", gap:6, marginBottom:14 }}>
        {[1,2,3,4,5].map(n => (
          <button key={n} disabled={readOnly} onClick={() => setStars(n)}
            style={{ fontSize:20, background:"none", border:"none", cursor:readOnly?"default":"pointer",
                     opacity:n<=rating?1:0.3, padding:0 }}>★</button>
        ))}
      </div>

      <div style={{ fontSize:13, fontWeight:600, color:"#444", marginBottom:8 }}>📝 Notities</div>
      {thread.length === 0 && <p style={{ fontSize:13, color:"#999", margin:"0 0 10px" }}>Nog geen notities.</p>}
      <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:12 }}>
        {thread.map((e, i) => {
          const u = Object.values(USERS).find(x => x.name === e.author);
          const mine = e.author === me;
          return (
            <div key={i} style={{ background: mentions(e.text, me) && !mine ? "#eef4fb" : "#faf8f4",
                                  border:"1px solid #ede8de", borderRadius:8, padding:"8px 11px" }}>
              <div style={{ fontSize:11, color:"#999", marginBottom:3 }}>
                {u?.emoji || "👤"} <b style={{ color:"#666" }}>{e.author || "?"}</b>
                {" · "}{new Date(e.ts).toLocaleDateString("nl-NL", { day:"numeric", month:"short" })}
              </div>
              <div style={{ fontSize:13, color:"#333", lineHeight:1.45 }}>{renderWithTags(e.text)}</div>
            </div>
          );
        })}
      </div>

      {!readOnly && (
        <div>
          <textarea value={draft} onChange={e => setDraft(e.target.value)}
            placeholder={`Notitie als ${me}… tag met @Matthijs of @Anna`}
            rows={2}
            style={{ width:"100%", fontSize:13, padding:"8px", border:"1px solid #ddd",
                     borderRadius:6, resize:"vertical", boxSizing:"border-box", fontFamily:"inherit" }} />
          <div style={{ display:"flex", gap:6, marginTop:6, alignItems:"center" }}>
            {NAMES.filter(nm => nm !== me).map(nm => (
              <button key={nm} onClick={() => setDraft(d => (d ? d + " " : "") + "@" + nm + " ")}
                style={{ fontSize:12, padding:"4px 10px", border:"1px solid #cfe0f3", background:"#eef4fb",
                         color:"#2d5a8e", borderRadius:14, cursor:"pointer" }}>@{nm}</button>
            ))}
            <div style={{ flex:1 }} />
            <button onClick={addEntry} disabled={!draft.trim()}
              style={{ padding:"6px 16px", background:draft.trim()?"#2d5a8e":"#bbb", color:"#fff",
                       border:"none", borderRadius:6, cursor:draft.trim()?"pointer":"default", fontSize:13 }}>
              Plaatsen
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
